const generatePath = (slug) => {
  if (!slug) return '/';
  if (slug === 'home') return '/';
  const formmatedSlug = slug.replace(/\./g, '/');
  if (slug.indexOf('staging') !== -1) return `/dev/${formmatedSlug}/`;
  return `/${formmatedSlug}/`;
};

module.exports = generatePath;
